<div
  class="table-header d-flex flex-wrap align-items-center s-p-4 border rounded-top border-bottom-0"
>
  <div class="col d-flex gap-1">
    <ng-content select="[slot=filter]"> </ng-content>
  </div>
  <div
    class="flex-grow-3 d-flex flex-row align-items-center justify-content-center gap-3 registers-count"
  >
    <p class="text-uppercase s-bold m-0">
      {{ title() ? title() : ('registers-total' | translate) }}
    </p>
    @if (total() !== undefined || value() !== undefined) {
      <div class="d-flex align-items-center border-start ps-3">
        <div class="d-flex align-items-center gap-2">
          <span class="s-heading-4">{{ total() || 0 }}</span>
        </div>
        @if (value() !== undefined) {
          <div class="d-flex align-items-center gap-2">
            <span class="text-uppercase s-bold text-muted" style="font-size: 0.75rem">{{
              totalLabel()
            }}</span>
            <span class="s-heading-3 m-0">{{ value() | currency: 'BRL' }}</span>
          </div>
        }
      </div>
    }
  </div>
  <div class="col d-flex justify-content-end gap-1">
    <ng-content select="[slot=actions]"> </ng-content>
  </div>
</div>
